import React from "react";
import "./NavbarStyles.css";
import { motion } from "framer-motion";
import { Component } from "react";
import Logo from "components/Logo";

class Navbar extends Component {
  state = { clicked: false };
  handleClick = () => {
    this.setState({ clicked: !this.state.clicked });
  };
  render() {
    return (
      <nav>
        <a href='/'>
          <Logo />
        </a>
        <div>
          <ul id='navbar' className={this.state.clicked ? "#navbar active" : "#navbar"}>
            <a href='/' className='links'>
              <motion.li whileHover={{ scale: 1.1, y: -2 }} whileTap={{ scale: 0.9, y: 0 }}>
                Home
              </motion.li>
            </a>
            <a href='/events' className='links'>
              <motion.li whileHover={{ scale: 1.1, y: -2 }} whileTap={{ scale: 0.9, y: 0 }}>
                Events
              </motion.li>
            </a>
            <a href='/resources' className='links'>
              <motion.li whileHover={{ scale: 1.1, y: -2 }} whileTap={{ scale: 0.9, y: 0 }}>
                Resources
              </motion.li>
            </a>
            <a href='/cvrepo' className='links'>
              <motion.li whileHover={{ scale: 1.1, y: -2 }} whileTap={{ scale: 0.9, y: 0 }}>
                CV&nbsp;Repo
              </motion.li>
            </a>
            <motion.li whileHover={{ scale: 1.1, y: -2 }} whileTap={{ scale: 0.9, y: 0 }}>
              <div className='dropdown'>
                <button className='dropbtn links'>Mentorship</button>
                <div className='dropdown-content'>
                  <a href='/mentorship/dashboard'>Dashboard</a>
                  <a href='/mentorship/leaderboard'>Leaderboard</a>
                </div>
              </div>
            </motion.li>
            <motion.li whileHover={{ scale: 1.1, y: -2 }} whileTap={{ scale: 0.9, y: 0 }}>
              <div className='dropdown'>
                <button className='dropbtn links'>Blogs</button>
                <div className='dropdown-content'>
                  <a href='/internblogs'>Internship Blogs</a>
                  <a href='/placementblogs'>Placement Blogs</a>
                  <a href='/adieublogs'>Adieu KGP</a>
                  <a href='/kyd'>Know Your Department</a>
                </div>
              </div>
            </motion.li>
            <a href='https://sr.swgiitkgp.org/' className='links' target="_blank">
              <motion.li whileHover={{ scale: 1.1, y: -2 }} whileTap={{ scale: 0.9, y: 0 }}>
                Subject&nbsp;Reviews
              </motion.li>
            </a>
            <a href='/about' className='links'>
              <motion.li whileHover={{ scale: 1.1, y: -2 }} whileTap={{ scale: 0.9, y: 0 }}>
                About
              </motion.li>
            </a>
          </ul>
        </div>
        <div id='mobile' onClick={this.handleClick}>
          <i id='bar' className={this.state.clicked ? "fas fa-times" : "fas fa-bars"}></i>

          {/* <i className='fas fa-bars'></i>
        <i className='fas fa-times'></i> */}
        </div>
      </nav>
    );
  }
}

export default Navbar;
